export default __webpack_public_path__ + "static/media/OPD_APPOINTMENT.48d978c4.png";